import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { css } from '@patternfly/react-styles';
export var DropdownToggleAction =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownToggleAction, _React$Component);

  function DropdownToggleAction() {
    _classCallCheck(this, DropdownToggleAction);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropdownToggleAction).apply(this, arguments));
  }

  _createClass(DropdownToggleAction, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          id = _a.id,
          className = _a.className,
          onClick = _a.onClick,
          isDisabled = _a.isDisabled,
          children = _a.children,
          props = __rest(_a, ["id", "className", "onClick", "isDisabled", "children"]);

      return React.createElement("button", Object.assign({
        id: id,
        className: css(styles.dropdownToggleButton, className),
        onClick: onClick
      }, isDisabled && {
        disabled: true,
        'aria-disabled': true
      }, props), children);
    }
  }]);

  return DropdownToggleAction;
}(React.Component);
DropdownToggleAction.defaultProps = {
  className: '',
  isDisabled: false,
  onClick: function onClick() {}
};